import Axios from 'axios';

import { cdnApiClient } from './cdnApiClient';
import { cdnApiPath } from './cdnApiPaths';

export const getUserAlerts = () => cdnApiClient.request(cdnApiPath('obs-alerts'));

export const createAlert = (requestData) => cdnApiClient.request(
  cdnApiPath('obs-alerts'),
  { method: 'POST', body: requestData },
);

export const updateAlert = (requestData) => cdnApiClient.request(
  cdnApiPath(`obs-alerts/${requestData.id}`),
  { method: 'PUT', body: { name: requestData.name } },
);

export const deleteAlert = (requestData) => cdnApiClient.request(
  cdnApiPath(`obs-alerts/${requestData.id}`),
  { method: 'DELETE' },
);

export const getUserAlertsHistory = (params) => cdnApiClient.request(
  cdnApiPath('obs-alert-events'),
  { queryParams: { alertStatus: 'active', ...(params || {}) } },
);

export const acknowledgeAlert = (alerts) => cdnApiClient.request(
  cdnApiPath('obs-alert-event-acknowledgements'),
  {
    method: 'PATCH',
    body: {
      acknowledgements: alerts.map((alert) => ({ obs_alert_event_uuid: alert.obs_alert_event_uuid })),
    },
  },
);

export const getUserPreferences = () => Axios.get('/data/preferences.json').then(({ data }) => data)
  .catch((err) => Promise.reject(err));

export const getUserFavoritePlatforms = () => cdnApiClient.request(cdnApiPath('obs-dataset-favorites'));

export const getUserFavoriteFilters = () => Axios.get('/data/favorites.json').then(({ data }) => data.filters);

export const createUserFavorite = (newFavorite) => cdnApiClient.request(
  cdnApiPath('obs-dataset-favorites'),
  { method: 'POST', body: newFavorite },
);

export const updateUserFavorite = (data) => cdnApiClient.request(
  cdnApiPath(`obs-dataset-favorites/${data.id}`),
  { method: 'PUT', body: { nickname: data.newNickname } },
);

export const deleteUserFavorite = (data) => cdnApiClient.request(
  cdnApiPath(`obs-dataset-favorites/${data.id}`),
  { method: 'DELETE' },
);

export const getUserPlatforms = () => Axios.get('/data/platforms.json').then(({ data }) => data)
  .catch((err) => Promise.reject(err));
